/// <reference types="@types/googlemaps" />

import { Base } from '@wilson/base';
import { Address } from '../addresses/address';
import { LocationCategory } from './locationCategory';

export enum LocationCodeType {
  Custom = 'custom',
  RINF = 'RINF',
}

export interface GeoLocation extends Base {
  name: string;
  locationCode: string | null;
  latitude: number;
  longitude: number;
  locationCategory?: LocationCategory;
  locationCategoryId: LocationCategory['id'];
  addressId: Address['id'] | null;
  address?: Address | null;
  description?: string;
  externalId?: string | null;
  isHighlighted?: boolean;
  organizationalUnitId?: string | null;
  locationCodeType?: LocationCodeType | null;
  isArchived: boolean;
}

export interface UserFavoriteGeoLocation {
  userId: string;
  locationId: string;
  location: GeoLocation;
}

export type GeoLocationWithFavorite = GeoLocation & {
  isFavorite: boolean;
};

export type LocationSuggestionWithFavorite = (
  | GeoLocation
  | google.maps.places.QueryAutocompletePrediction
) & {
  isFavorite: boolean;
};

export type MinimalGeoLocation = Pick<
  GeoLocation,
  | 'id'
  | 'name'
  | 'address'
  | 'latitude'
  | 'longitude'
  | 'locationCode'
  | 'isHighlighted'
  | 'locationCategory'
  | 'locationCodeType'
>;
